<template>
  <div>
    <v-row>
      <v-col>
        <template>
          <v-file-input
            accept=".xlsx, .xls, .csv"
            label="Select File"
            outlined
            v-model="selectXlsx"
            show-size
            @change="uploadXlsx"
          >
          </v-file-input>
        </template>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import XLSX from "xlsx";

export default {
  data: () => ({ selectXlsx: null }),
  methods: {
    uploadXlsx() {
      if (!this.selectXlsx) {
        return;
      }
      if (this.selectXlsx) {
        const reader = new FileReader();
        reader.onload = (e) => {
          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, { type: "binary" });
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
          const data = XLSX.utils.sheet_to_json(ws, { header: 1 });

          this.$emit("get-json", data);
        };

        reader.readAsBinaryString(this.selectXlsx);
      }
      this.selectXlsx = null;
    },
  },
};
</script>
